var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarshipTitania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #209100;\n      }\n\n      .cls-2 {\n        fill: #e2e2e2;\n      }\n\n      .cls-3 {\n        fill: #1c1c1c;\n      }\n\n      .cls-4 {\n        fill: #454545;\n      }\n\n      .cls-5 {\n        fill: #dbdbdb;\n      }\n\n      .cls-6 {\n        fill: #fff;\n        opacity: .15;\n      }\n\n      .cls-7 {\n        fill: #1fa000;\n      }\n\n      .cls-8 {\n        fill: #262626;\n      }\n\n      .cls-9 {\n        fill: #218700;\n      }\n\n      .cls-10 {\n        fill: #565656;\n      }\n\n      .cls-11 {\n        fill: #0c0c0c;\n      }\n\n      .cls-12 {\n        fill: #9e9e9e;\n      }\n\n      .cls-13 {\n        fill: #afafaf;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "685.03 362.01 110.45 335.89 114.02 300.37 226.24 243.21 685.03 362.01"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "119.95 374.73 90.74 367.18 90.74 331.82 119.95 324.28 119.95 374.73"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "628.64 398.85 398.31 408.84 465.88 376.82 628.64 389.93 628.64 398.85"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "83.99 400.24 226.02 463.43 685.03 362.01 83.99 400.24"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "685.03 362.01 110.25 339.39 83.99 300.38 226.21 243.23 685.03 362.01"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "226.29 448.85 83.99 400.24 110.25 359.39 685.03 362.01 226.29 448.85"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "226.02 448.64 83.72 400.02 110.25 359.39 226.02 396.69 226.02 448.64"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "226.21 243.23 226.21 314.36 434.25 344.39 338.25 283.39 226.21 243.23"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "226.25 243.39 226.25 314.39 685.03 362.01 226.25 243.39"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.42 359.32 226.21 406.25 685.03 362.01 110.42 359.32"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "685.03 362.01 226.21 375.24 110.42 359.32 130.42 349.5 110.42 339.76 226.21 314.36 685.03 362.01 685.03 362.01"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "110.23 359.32 101.02 372.33 226.02 406.25 226.25 375.39 110.23 359.32"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "226.25 375.39 110.25 359.39 113.24 349.5 110.24 339.35 226.03 313.95 226.25 375.39"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "226.25 463.39 88.02 408.33 84.25 400.39 226.25 449.39 226.25 463.39"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "685.61 362.31 226.61 273.31 93.02 313.33 84.61 301.31 226.61 244.31 685.61 362.31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarshipTitania);
export default __webpack_public_path__ + "static/media/starship-titania.89bf0fbdddbf62d2207072805138bfbb.svg";
export { ForwardRef as ReactComponent };